import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Avatar, Dropdown, Typography } from 'antd';
import {
  LayoutDashboard, Users, Building2, TrendingUp,
  Calendar, LogOut, Menu as MenuIcon, ChevronLeft, User, FileText, FolderOpen, Settings, Calculator, UserCog, BookUser,
} from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

const { Sider, Header, Content } = Layout;
const { Text } = Typography;

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isAdmin, hasModule } = useAuthStore();

  const allMenuItems = [
    { key: '/', icon: <LayoutDashboard size={18} />, label: 'Dashboard', module: null },
    { key: '/leads', icon: <Users size={18} />, label: 'Leads', module: 'leads' },
    { key: '/properties', icon: <Building2 size={18} />, label: 'Propiedades', module: 'properties' },
    { key: '/opportunities', icon: <TrendingUp size={18} />, label: 'Oportunidades', module: 'opportunities' },
    { key: '/meetings', icon: <Calendar size={18} />, label: 'Reuniones', module: 'meetings' },
    { key: '/blog', icon: <FileText size={18} />, label: 'Blog', module: 'blog' },
    { key: '/assets', icon: <FolderOpen size={18} />, label: 'Assets', module: 'assets' },
    { key: '/integrations', icon: <Settings size={18} />, label: 'Integraciones', module: 'integrations' },
    { key: '/avm', icon: <Calculator size={18} />, label: 'Valorador AVM', module: 'avm' },
    { key: '/particulares', icon: <BookUser size={18} />, label: 'Listado Particulares', module: 'listado-particulares' },
    { key: '/users', icon: <UserCog size={18} />, label: 'Usuarios', module: '__admin__' },
  ];

  const menuItems = allMenuItems.filter(item => {
    if (item.module === null) return true;
    if (item.module === '__admin__') return isAdmin();
    return hasModule(item.module);
  });

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    { key: 'profile', icon: <User size={14} />, label: 'Mi perfil' },
    { key: 'logout', icon: <LogOut size={14} />, label: 'Cerrar sesión', danger: true },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        style={{ background: '#1F2F3F' }}
        width={240}
      >
        <div style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}>
          <Text strong style={{ color: '#cfb56b', fontSize: collapsed ? 18 : 22, fontFamily: 'Georgia, serif' }}>
            {collapsed ? 'S' : 'Swomey'}
          </Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{
            background: 'transparent',
            borderRight: 'none',
            color: 'rgba(255,255,255,0.8)',
            marginTop: 8,
          }}
          theme="dark"
        />
      </Sider>
      <Layout>
        <Header style={{
          background: '#fff',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #f0f0f0',
          boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuIcon size={18} /> : <ChevronLeft size={18} />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <Dropdown
            menu={{
              items: userMenuItems,
              onClick: ({ key }) => {
                if (key === 'logout') handleLogout();
              },
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <Avatar style={{ backgroundColor: '#1F2F3F' }}>
                {user?.name?.charAt(0)?.toUpperCase() || 'U'}
              </Avatar>
              <Text>{user?.name || 'Usuario'}</Text>
            </div>
          </Dropdown>
        </Header>
        <Content
          className="dashboard-content"
          style={{ margin: 24, padding: 24, background: '#f5f5f5', borderRadius: 8, overflow: 'auto' }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
